import { Outlet } from "react-router-dom";
import Header from "@/components/Header";
import Sidebar from "@/components/Sidebar";
import Paywall from "@/components/Paywall";
import TrialBanner from "@/components/TrialBanner";
import TermsAcceptanceGate from "@/components/TermsAcceptanceGate";
import { useState } from "react";

export default function AppShell() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="h-screen w-full flex flex-col overflow-hidden relative z-10">
      <TrialBanner />
      <Header onMenuClick={() => setSidebarOpen((v) => !v)} />
      <div className="flex-1 flex overflow-hidden">
        <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <main className="flex-1 overflow-hidden relative" data-testid="app-main">
          <Outlet />
        </main>
      </div>
      <Paywall />
      <TermsAcceptanceGate />
    </div>
  );
}
